import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ["triggerInput", "conditionalElement"]
  static values = {
    cost: { type: Number, default: 0 },
    budget: { type: Number, default: 0 },
  }

  connect() {
    const trigger = new CustomEvent("selectedRecordsChanged", {
      detail: {
        campaignCost: this.costValue,
        campaignBudget: this.budgetValue
      }
    });
    window.dispatchEvent(trigger);
  }
}